import axios from 'axios';
import { API_BASE_URL } from '../config';
import Cookies from 'js-cookie';


// Create axios instance
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
apiClient.interceptors.request.use(
  (config) => {
    const token = Cookies.get('idToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Authentication APIs
export const loginUser = async (email, password) => {
  const response = await apiClient.post('/auth/login', { email, password });
  return response.data;
};

export const refreshAuthToken = async (refreshToken) => {
  const response = await apiClient.post('/auth/refresh', { refreshToken });
  return response.data;
};

export const resetPassword = async (email) => {
  const response = await apiClient.post('/auth/reset-password', { email });
  return response.data;
};

export const verifyToken = async (idToken) => {
  const response = await apiClient.post('/auth/verify', { idToken });
  return response.data;
};

export const logoutUser = async () => {
  const response = await apiClient.post('/auth/logout');
  return response.data;
};

// Alumni APIs
export const getAlumniList = async (filters = {}) => {
  const response = await apiClient.get('/alumni/list', { params: filters });
  return response.data;
};

export const getAlumniProfile = async (email) => {
  const response = await apiClient.get(`/alumni/profile/${email}`);
  return response.data;
};

export const registerAlumni = async (data) => {
  const response = await apiClient.post('/alumni/register', data);
  return response.data;
};

export const getFilterOptions = async () => {
  const response = await apiClient.get('/alumni/filters');
  return response.data;
};

// Admin APIs
export const getAddRequests = async () => {
  const response = await apiClient.get('/admin/add-requests');
  return response.data;
};

export const approveAddRequest = async (index) => {
  const response = await apiClient.post(`/admin/add-requests/approve/${index}`);
  return response.data;
};

export const denyAddRequest = async (index) => {
  const response = await apiClient.post(`/admin/add-requests/deny/${index}`);
  return response.data;
};

export const getBusinessRequests = async () => {
  const response = await apiClient.get('/admin/business-requests');
  return response.data;
};

export const approveBusinessRequest = async (index) => {
  const response = await apiClient.post(`/admin/business-requests/approve/${index}`);
  return response.data;
};

export const denyBusinessRequest = async (index) => {
  const response = await apiClient.post(`/admin/business-requests/deny/${index}`);
  return response.data;
};

export const addAlumniDirectly = async (data) => {
  const response = await apiClient.post('/admin/alumni/add', data);
  return response.data;
};

// Statistics APIs
export const getDegreeBreakdown = async () => {
  const response = await apiClient.get('/statistics/degree-breakdown');
  return response.data;
};

export const getGraduationTrends = async () => {
  const response = await apiClient.get('/statistics/graduation-trends');
  return response.data;
};

export const getGenderDistribution = async () => {
  const response = await apiClient.get('/statistics/gender-distribution');
  return response.data;
};

export const getGeographicalDistribution = async () => {
  const response = await apiClient.get('/statistics/geographical-distribution');
  return response.data;
};

export const getHonorsDistribution = async () => {
  const response = await apiClient.get('/statistics/honors-distribution');
  return response.data;
};

export const getContactCompleteness = async () => {
  const response = await apiClient.get('/statistics/contact-completeness');
  return response.data;
};

export const getSummaryStatistics = async () => {
  const response = await apiClient.get('/statistics/summary');
  return response.data;
};

// Business APIs
export const submitBusinessApplication = async (data) => {
  const response = await apiClient.post('/business/apply', data);
  return response.data;
};

export const getApprovedBusinesses = async () => {
  const response = await apiClient.get('/business/approved');
  return response.data;
};

export default apiClient;
